import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PromptUpdateService } from 'src/app/services/prompt-update.service';

@Component({
  selector: 'app-app-update-dialog-box',
  templateUrl: './app-update-dialog-box.component.html',
  styleUrls: ['./app-update-dialog-box.component.scss']
})
export class AppUpdateDialogBoxComponent implements OnInit, OnDestroy {

  displayAppUpdateDialogBox = false;
  displayDialogBoxSubscription: Subscription;

  constructor(private appUpdateService: PromptUpdateService) { }

  ngOnInit(): void {
    this.displayDialogBoxSubscription = this.appUpdateService.displayAppUpdateDialogBox$.subscribe(
      showDialogBox => this.displayAppUpdateDialogBox = showDialogBox
    )
  }

  reloadApp(){
    this.appUpdateService.updateApp();
  }

  ngOnDestroy(): void {
    this.displayDialogBoxSubscription.unsubscribe();
  }
}
